<head>
  <title>TMS Reports</title>
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
    integrity="sha512-iecdLmaskl7CVkqkXNQ/ZH/XLlvWZOJyj7Yy7tcenmpD1ypASozpmT/E0iPtmFIB46ZmdtAc9eNBvH0H/ZpiBw=="
    crossorigin="anonymous" referrerpolicy="no-referrer" />
</head>

<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>

<div class="row ps-0">
  <app-breadcrumb></app-breadcrumb>
  <div class="col-md-2">
    <label for="email" id="manageReportNameAlert" style="margin-top: 12px;"><b> Report<span
          class="mandatory-symbol">*</span> &nbsp;: &nbsp; </b></label>
    <mat-select matInput placeholder="Select" [(ngModel)]="searchByReportCodeMain" (closed)="groupSearchText=''"
      (click)="focusSearch('focus-title-search3')" (keydown.enter)="focusSearch('focus-title-search3')">
      <input type="search" id="focus-title-search3" class="dropdownsearchstyle" [(ngModel)]="groupSearchText" matInput
        placeholder="search">
      <mat-option class="unselectStyle" [value]="null"
        (onSelectionChange)="onReportTypeSelectnew($event,null);">Un-select</mat-option>
      <mat-option *ngFor="let item of reportListDropdown | assessmentSearch : groupSearchText;"
        (onSelectionChange)="onReportTypeSelectnew($event,item)" [value]="item.valueExp">
        {{ item.displayExp }}
      </mat-option>
    </mat-select>
  </div>
  <div class="col-md-5">
    <div class="row" *ngIf="selectedOption=='Users'">
      <div class="row">
        <div class="col-md-12">
          <div class="col-md-4"></div>
          <div class="col-md-8" style=" justify-content: left; margin-left: 88px; ">
            <label for="email" id="userNameAlert" style="margin-top: 9px;"><b>User Name
                &nbsp;: &nbsp;
              </b></label>
            <div style="display: flex; ">
              <div class="col-sm-6" style="position: relative;">
                <input style="cursor: not-allowed; height: 35px; " type="text" class="userNametextbox"
                  [(ngModel)]="searchUserName" disabled>
              </div>&nbsp;&nbsp;
              <div class="col-sm-1 search-icon" (click)="openSearchUserPopup('ToUser')"
                (keydown.enter)="openSearchUserPopup('ToUser')" style="margin-top: 7px;">
                <i class="fa fa-search fa-1x"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row"> <br></div>
      <div class="row">
        <div class="d-flex gap-3 my-3 ms-2">
          <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="getUsers()"
            (keydown.enter)="getUsers()">
            <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
            <span class="reload_text text-white">Generate</span>
          </div>
          <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center"
            (click)="resetFunction()" (keydown.enter)="resetFunction()">
            <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reset" />
            <span class="reload_text">Reset</span>
          </div>
        </div>
      </div>

    </div>
    <div class="row" *ngIf="selectedOption=='Team Member Trainings'">
      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-11">
          <div style=" justify-content: center;">
            <label for="email" id="managerNameAlert" style="margin-top: 9px;"><b>Manager Name <span
                  class="mandatory-symbol">*</span>
                &nbsp; : &nbsp;
              </b></label>
            <div style=" display: flex;">
              <div class="col-sm-6">
                <input style="cursor: not-allowed; height: 35px;" type="text" class="userNametextbox"
                  [(ngModel)]="searchUserName" disabled>
              </div>&nbsp;&nbsp;
              <div class="col-sm-1 search-icon" (click)="openSearchUserPopup('ToUser')"
                (keydown.enter)="openSearchUserPopup('ToUser')" style="margin-top: 7px;">
                <i class="fa fa-search fa-1x"></i>
              </div>
            </div>
          </div>
        </div>
        &nbsp;&nbsp;
        <div class="row"> <br></div>
        <div class="row">
          <div class="d-flex gap-3 my-3 ms-2">
            <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="getUsers()"
              (keydown.enter)="getUsers()">
              <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
              <span class="reload_text text-white">Generate</span>
            </div>
            <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center"
              (click)="resetFunction()" (keydown.enter)="resetFunction()">
              <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reset" />
              <span class="reload_text">Reset</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="selectedOption=='Trainings'">
      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-7">
          <label for="email" style="margin-top: 9px;" id="trainingNameAlert"><b>Training Name &nbsp;: &nbsp;</b></label>
          <div style="display: flex; ">
            <div class="col-sm-7" style="position: relative;">
              <input style="cursor: not-allowed; height: 35px; " type="text" class="userNametextbox"
                [(ngModel)]="getSelectedTrainingName" disabled>
            </div>&nbsp;&nbsp;
            <div class="col-sm-1 search-icon" (click)="searchTrainingFunction()" style="margin-top: 7px;">
              <i class="fa fa-search fa-1x"></i>
            </div>
          </div>
        </div>
      </div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <div class="row"> <br></div>
      <div class="row">
        <div class="d-flex gap-3 my-3 ms-2">
          <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="getUsers()"
            (keydown.enter)="getUsers()">
            <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
            <span class="reload_text text-white">Generate</span>
          </div>
          <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center"
            (click)="resetFunction()" (keydown.enter)="resetFunction()">
            <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reset" />
            <span class="reload_text">Reset</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="selectedOption=='Training Groups'">
      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-6">
          <label for="email" id="groupNameAlert" style="margin-top: 10px;">Group <span
              class="mandatory-symbol">*</span>&nbsp;: &nbsp;</label>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedGroup" (closed)="groupSearchText=''"
            (click)="focusSearch('focus-title-focus-title-search2')"
            (keydown.enter)="focusSearch('focus-title-focus-title-search2')">
            <input type="search" id="focus-title-search2" class="dropdownsearchstyle" [(ngModel)]="groupSearchText"
              matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null"
              (onSelectionChange)="onGroupSelectnew($event,null);">Un-select</mat-option>
            <mat-option *ngFor="let item of groupValueDropdown | assessmentSearch : groupSearchText;"
              (onSelectionChange)="onGroupSelectnew($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <div class="row"> <br></div>
      <div class="row">
        <div class="d-flex gap-3 my-3 ms-2">
          <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
            (click)="getUsersForGroup()" (keydown.enter)="getUsersForGroup()">
            <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
            <span class="reload_text text-white">Generate</span>
          </div>
          <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center"
            (click)="resetFunction()" (keydown.enter)="resetFunction()">
            <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reset" />
            <span class="reload_text">Reset</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="selectedOption=='Instructor Trainings'">
      <div class="row" style="margin-top:10px">
        <div class="col-md-2"></div>
        <div class="col-md-3" style="position: relative;">
          <label for=" "><b> Show Trainer</b></label>
          <br>
          <div>
            <input type="checkbox" style="zoom: 1.2;margin-top: 3px;margin-left: 51px;" [checked]="showTrainerLevel"
              (change)="showTrainerLevelFcn($event)">
          </div>
        </div>
        <div class="col-md-7" *ngIf="showTrainerLevel==false">
          <label for="email" id="instructorTrainingNameAlert"><b>Instructor Training Name : </b></label>
          <div style="display: flex; ">
            <div class="col-sm-7" style="position: relative;">
              <input style="cursor: not-allowed; height: 35px;" type="text" class="userNametextbox"
                [(ngModel)]="getSelectedInstructorTrainingName" disabled>
            </div>&nbsp;&nbsp;
            <div class="col-sm-1 search-icon" (click)="searchInstructorTrainingFunction()"
              (keydown.enter)="searchInstructorTrainingFunction()" style="margin-top: 7px;">
              <i class="fa fa-search fa-1x"></i>
            </div>
          </div>
        </div>
        <div class="col-md-5" *ngIf="showTrainerLevel">
          <div>
            <label for="email"><b>Select Trainer &nbsp;: &nbsp;
              </b></label>
          </div>
          <mat-select matInput multiple placeholder="Select" #documentType style="position: absolute; width: 18%;"
            [(ngModel)]="searchByInstructorTrainer" (closed)="trainerSearchText=''"
            (click)="focusSearch('document-type-search1')" (keydown.enter)="focusSearch('document-type-search1')">
            <input type="search" id="document-type-search1" class="dropdownsearchstyle" [(ngModel)]="trainerSearchText"
              matInput placeholder="search">
            <mat-option
              *ngFor="let item of getTmsInstructorTrainerDataList | multiAssessmentSearchPipe : trainerSearchText"
              [value]="item.valueExp" (onSelectionChange)="onTraininerSelectAllnew($event,item)">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>
      <div class="row"> <br></div>
      <div class="row">
        <div class="d-flex gap-3 my-3 ms-2">
          <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
            (click)="getUsersInstructorTraining()" (keydown.enter)="getUsersInstructorTraining()">
            <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
            <span class="reload_text text-white">Generate</span>
          </div>
          <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center"
            (click)="resetFunction()" (keydown.enter)="resetFunction()">
            <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reset" />
            <span class="reload_text">Reset</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="selectedOption=='Department'">
      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-3">
          <label for="email" id="departmentNameAlert" style="margin-top: 10px;"><b> Department &nbsp;: &nbsp;
            </b></label><br>
          <mat-select matInput multiple placeholder="Select" #documentType style="position: absolute; width: 18%;"
            [(ngModel)]="searchByDepartmentCodeMain" (closed)="departmentSearchText=''"
            (click)="focusSearch('document-type-search')" (keydown.enter)="focusSearch('document-type-search')">
            <input type="search" id="document-type-search" class="dropdownsearchstyle"
              [(ngModel)]="departmentSearchText" matInput placeholder="search">
            <mat-option *ngFor="let item of departmentListDropdown | multiAssessmentSearchPipe : departmentSearchText"
              [value]="item.valueExp" (onSelectionChange)="onModuleSelectAllnew($event,item)">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <div class="row"> <br></div>
      <div class="row">
        <div class="d-flex gap-3 my-3 ms-2">
          <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="getUsers()"
            (keydown.enter)="getUsers()">
            <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
            <span class="reload_text text-white">Generate</span>
          </div>
          <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center"
            (click)="resetFunction()" (keydown.enter)="resetFunction()">
            <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reset" />
            <span class="reload_text">Reset</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-4" *ngIf="message.showRetakeAndMarkasCompleted==false">
    <h3 class="reports_title">Reports</h3>
    <div class="d-flex justify-content-between">
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.service.tmsReportButtonVal   === 'Default'}"
        (click)="moreActivityReportDetails('Default',1)" (keydown.enter)="moreActivityReportDetails('Default',1)"
        style=" cursor: pointer;">
        <div class="reports_block">
          <img src="../../assets/img/DMS/circle.png" width="16px" height="16px" alt="Default">
        </div>
        <p class="report_subtext">Default</p>
      </div>
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.service.tmsReportButtonVal   === 'Milestone'}"
        (click)="moreActivityReportDetails('Milestone',2)" (keydown.enter)="moreActivityReportDetails('Milestone',2)"
        style=" cursor: pointer;">
        <div class="reports_block">
          <img src="../../assets/img/DMS/milestone.svg" width="16px" height="16px" alt="Milestone">
        </div>
        <p class="report_subtext">Milestone</p>
      </div>
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.service.tmsReportButtonVal   === 'Training Vs Group'}"
        (click)="moreActivityReportDetails('Training Vs Group',2)"
        (keydown.enter)="moreActivityReportDetails('Training Vs Group',2)" style=" cursor: pointer;">
        <div class="reports_block">
          <img src="../../assets/img/DMS/actions.svg" width="16px" height="16px" alt="Training Vs Group">
        </div>
        <p class="report_subtext">Training Vs Group</p>
      </div>
    </div>
    <div class="d-flex justify-content-between mt-4">
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.service.tmsReportButtonVal === 'Unmapped Trainings'}"
        (click)="moreActivityReportDetails('Unmapped Trainings',2)"
        (keydown.enter)="moreActivityReportDetails('Unmapped Trainings',2)" style=" cursor: pointer;">
        <div class="reports_block">
          <img src="../../assets/img/DMS/extension.svg" width="16px" height="16px" alt="Unmapped Trainings">
        </div>
        <p class="report_subtext">Unmapped Trainings</p>
      </div>
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.service.tmsReportButtonVal === 'Expiry Date'}"
        (click)="moreActivityReportDetails('Expiry Date',2)"
        (keydown.enter)="moreActivityReportDetails('Expiry Date',2)" style=" cursor: pointer;  margin-left: 40px;">
        <div class="reports_block">
          <img src="../../assets/img/DMS/overdue.svg" width="16px" height="16px" alt="Expiry Date">
        </div>
        <p class="report_subtext">Expiry Date</p>
      </div>
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.service.tmsReportButtonVal === 'Conclusive Trail'}"
        (click)="moreActivityReportDetails('Conclusive Trail',3)"
        (keydown.enter)="moreActivityReportDetails('Conclusive Trail',3)" style=" cursor: pointer;  margin-left: 40px;">
        <div class="reports_block">
          <img src="../../assets/img/trail-overall.svg" width="20px" height="20px" alt="add new" />
        </div>
        <p class="report_subtext">Conclusive Audit Trail</p>
      </div>
    </div>
  </div>
  <div style="background: #FFF; border-bottom: 1px solid #005C8A; border-radius: 4%; margin-top:10px">

  </div>
  &nbsp;&nbsp;&nbsp;&nbsp;
  <!-- main grid-->
  <div class="row" style="margin-top:10px;" *ngIf="totalVal!=0" #captureDiv>
    <div class="menu-container">
      <div class="row menu-row-container">
        <div class="col-sm-6 gridName-container">
          <span class="tms-reports_title">{{selectedOption}}</span>
        </div>
        <div class="col-sm-6 action-buttons-container" style="margin-left: 52%;margin-top: -27px;">
          <div *ngIf="!notCompleted"><label for="email">Expand Details</label>
          </div>
          <div *ngIf="notCompleted"><label for="email">Collapse Details</label>
          </div>
          &nbsp;&nbsp;
          <mat-slide-toggle color="primary" (ngModelChange)="showNotCompleted()"
            [(ngModel)]="notCompleted"></mat-slide-toggle>
          &nbsp;&nbsp;
          <div (click)="captureElement()" (keydown.enter)="captureElement()" matTooltip="Download Screenshot"><i
              class="fas fa-download"></i>

          </div>
          &nbsp;&nbsp;
          <div (click)="openReportPopupOrgMain('main')" (keydown.enter)="openReportPopupOrgMain('main')">
            <i class="fa fa-file-excel-o" style="font-size:18px;color:bule"></i>
          </div>
        </div>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-md-9" *ngIf="notCompleted && selectedOption != 'Organization'">
        <div class="panel">
          <div class="detail-menu-container">
            <div class="mini-chart-container1" (click)="overAllGetDetails('All')"
              (keydown.enter)="overAllGetDetails('All')">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu">
                    <img src="../../../assets/img/cr_module/total_requests.svg" width="16px" height="16px"
                      alt="Total" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{totalVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Total
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container1" (click)="overAllGetDetails('PENDING')"
              (keydown.enter)="overAllGetDetails('PENDING')">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu pending_request">
                    <img src="../../../assets/img/tms/yet.svg" width="16px" height="16px" alt="Pending" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{pendingVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Pending
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container1" (click)="overAllGetDetails('COMPLETED')"
              (keydown.enter)="overAllGetDetails('COMPLETED')">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu active_request">
                    <img src="../../../assets/img/tms/pass.svg" width="16px" height="16px" alt="Completed" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{completedVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Completed
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container1" (click)="overAllGetDetails('FAILED')"
              (keydown.enter)="overAllGetDetails('FAILED')">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu overdue_request">
                    <img src="../../../assets/img/tms/fail.svg" width="16px" height="16px" alt="Failed" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{failedVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Failed
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container1" (click)="overAllGetDetails('SCHEDULED')"
              (keydown.enter)="overAllGetDetails('SCHEDULED')">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu other_request">
                    <img src="../../../assets/img/tms/sch.svg" width="16px" height="16px" alt="Scheduled" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{scheduledVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Scheduled
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container1" (click)="overAllGetDetails('INPROGRESS')"
              (keydown.enter)="overAllGetDetails('INPROGRESS')">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu inpro_request">
                    <img src="../../../assets/img/processing-time.png" width="16px" height="16px" alt="Inprogress" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{inprogressVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Inprogress
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container1" (click)="overAllGetDetails('OVERDUE')"
              (keydown.enter)="overAllGetDetails('OVERDUE')">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu over_request">
                    <img src="../../../assets/img/time.png" width="16px" height="16px" alt="Overdue" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{overdueVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Overdue
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container1" (click)="overAllGetDetails('LOCKED')"
              (keydown.enter)="overAllGetDetails('LOCKED')">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu lock_request">
                    <img src="../../../assets/img/padlock (1).png" width="16px" height="16px" alt="Locked" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{lockedVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Locked
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container1" style="cursor: default;">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu my_total_request">
                    <img src="../../../assets/img/tms/per.svg" width="16px" height="16px" alt="%" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{passPerVal}} %
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Pass
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="table-container">
          <div class="table-header1">
            <div class="table-cell-th1 name" style="min-width: 200px;"
              *ngIf="selectedOption=='Users' || selectedOption=='Team Member Trainings' || selectedOption=='Organization'">
              User Name</div>
            <div class="table-cell-th1 name" style="min-width: 200px;" *ngIf="selectedOption=='Department'">Department
            </div>
            <div class="table-cell-th1 name" style="min-width: 200px;" *ngIf="selectedOption=='Training Groups'">User
              Name</div>
            <div class="table-cell-th1" style="min-width: 200px;"
              *ngIf="selectedOption=='Trainings' || selectedOption=='Instructor Trainings'">
              Training Name
            </div>
            <div class="table-cell-th1" *ngIf="selectedOption=='Trainings' || selectedOption=='Instructor Trainings'"
              style="min-width: 60px;">
              Version</div>
            <div class="table-cell-th1"
              [style.min-width]="(selectedOption=='Trainings' || selectedOption=='Instructor Trainings') ? '60px' : '80px'">
              Total</div>
            <div class="table-cell-th1" style="min-width: 80px;">Pending</div>
            <div class="table-cell-th1" style="min-width: 80px;">Completed</div>
            <div class="table-cell-th1"
              [style.min-width]="(selectedOption=='Trainings' || selectedOption=='Instructor Trainings') ? '60px' : '80px'">
              Failed</div>
            <div class="table-cell-th1" style="min-width: 80px;">Scheduled</div>
            <div class="table-cell-th1" style="min-width: 80px;">Inprogress</div>
            <div class="table-cell-th1" style="min-width: 80px;">Overdue</div>
            <div class="table-cell-th1"
              [style.min-width]="(selectedOption=='Trainings' || selectedOption=='Instructor Trainings') ? '60px' : '80px'">
              Locked</div>
            <div class="table-cell-th1" style="min-width: 80px;">Failed Attempts</div>
            <div class="table-cell-th1"
              [style.min-width]="(selectedOption=='Trainings' || selectedOption=='Instructor Trainings') ? '70px' : '80px'">
              Pass %</div>
          </div>
          <div class="table-row1" *ngFor="let listOfUsersData of pagedItemsMain; let idx = index;">
            <div class="table-cell1 name clickable nameAlign" style="min-width: 200px;"
              *ngIf="selectedOption=='Users' || selectedOption=='Team Member Trainings' || selectedOption=='Organization'"
              (click)="getDetails(idx,'All')" (keydown.enter)="getDetails(idx,'All')"
              [title]="listOfUsersData.usrFullname">
              {{listOfUsersData.usrFullname}}
            </div>
            <div class="table-cell1 name clickable nameAlign" style="min-width: 200px;"
              *ngIf="selectedOption=='Training Groups'" (click)="getDetails(idx,'All')"
              (keydown.enter)="getDetails(idx,'All')" [title]="listOfUsersData.userName">
              {{listOfUsersData.userName}}
            </div>
            <div class="table-cell1 name clickable nameAlign" style="min-width: 200px;"
              *ngIf="selectedOption=='Department'" (click)="getDetails(idx,'All')"
              (keydown.enter)="getDetails(idx,'All')">
              {{listOfUsersData.departmentCode}}
            </div>
            <div class="table-cell1 name clickable nameAlign" style="min-width: 200px;"
              *ngIf="selectedOption=='Trainings' || selectedOption=='Instructor Trainings'"
              (click)="getDetails(idx,'All')" (keydown.enter)="getDetails(idx,'All')"
              [title]="listOfUsersData.trainingName">
              {{listOfUsersData.trainingName}}
            </div>
            <div class="table-cell1  clickable valueAlign" style="min-width: 60px;"
              *ngIf="selectedOption=='Trainings' || selectedOption=='Instructor Trainings'">
              {{listOfUsersData.version}}
            </div>
            <div class="table-cell1 clickable valueAlign"
              [style.min-width]="(selectedOption=='Trainings' || selectedOption=='Instructor Trainings') ? '60px' : '80px'"
              (click)="getDetails(idx,'All')" (keydown.enter)="getDetails(idx,'All')">
              {{listOfUsersData.total}}
            </div>
            <div class="table-cell1 clickable valueAlign" style="min-width: 80px;" (click)="getDetails(idx,'PENDING')"
              (keydown.enter)="getDetails(idx,'PENDING')">
              {{listOfUsersData.pending}}
            </div>
            <div class="table-cell1 clickable valueAlign" style="min-width: 80px;" (click)="getDetails(idx,'COMPLETED')"
              (keydown.enter)="getDetails(idx,'COMPLETED')">
              {{listOfUsersData.completed}}
            </div>
            <div class="table-cell1 clickable valueAlign"
              [style.min-width]="(selectedOption=='Trainings' || selectedOption=='Instructor Trainings') ? '60px' : '80px'"
              (click)="getDetails(idx,'FAILED')" (keydown.enter)="getDetails(idx,'FAILED')">
              {{listOfUsersData.failed}}
            </div>
            <div class="table-cell1 clickable valueAlign" style="min-width: 80px;" (click)="getDetails(idx,'SCHEDULED')"
              (keydown.enter)="getDetails(idx,'SCHEDULED')">
              {{listOfUsersData.scheduled}}
            </div>
            <div class="table-cell1 clickable valueAlign" style="min-width: 80px;"
              (click)="getDetails(idx,'INPROGRESS')" (keydown.enter)="getDetails(idx,'INPROGRESS')">
              {{listOfUsersData.inprogress}}
            </div>
            <div class="table-cell1 clickable valueAlign" style="min-width: 80px;" (click)="getDetails(idx,'OVERDUE')"
              (keydown.enter)="getDetails(idx,'OVERDUE')">
              {{listOfUsersData.overdue}}
            </div>
            <div class="table-cell1 clickable valueAlign"
              [style.min-width]="(selectedOption=='Trainings' || selectedOption=='Instructor Trainings') ? '60px' : '80px'"
              (click)="getDetails(idx,'LOCKED')" (keydown.enter)="getDetails(idx,'LOCKED')">
              {{listOfUsersData.locked}}
            </div>
            <div class="table-cell1 valueAlign" style="min-width: 80px;">
              {{listOfUsersData.failedAttempts}}
            </div>
            <div class="table-cell1 valueAlignC"
              [style.min-width]="(selectedOption=='Trainings' || selectedOption=='Instructor Trainings') ? '70px' : '80px'">
              {{(listOfUsersData.completed / listOfUsersData.total * 100).toFixed(1)}}%
            </div>
          </div>
        </div>
        <div *ngIf="collectionSize>10">
          <div class="row border-top mt-1 width-cheat small paginationCell">
            <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
            </nav>
            <div class="col-2 col-md-6 d-flex justify-content-end align-items-center">
            </div>
            <nav class="col-6 col-md-4 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
              1-{{ perPage }} of {{ collectionSize | number }}
              <ngb-pagination class="leftpadding" (pageChange)="setPageMain(pager.currentPage,$event)"
                [disabled]="false" [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize"
                [rotate]="true" [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
              </ngb-pagination>
              <div ngbDropdown class="d-inline-block leftpadding">
                <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
                  {{perPage}}
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                  <button ngbDropdownItem (click)="paginationCallMain(10)">10</button>
                  <button ngbDropdownItem (click)="paginationCallMain(20)">20</button>
                  <button ngbDropdownItem (click)="paginationCallMain(50)">50</button>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
      <div class="col-md-9" *ngIf="!notCompleted && selectedOption != 'Organization'">
        <div class="panel">
          <div class="detail-menu-container">
            <div class="mini-chart-container" (click)="overAllGetDetails('All')"
              (keydown.enter)="overAllGetDetails('All')">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu">
                    <img src="../../../assets/img/cr_module/total_requests.svg" width="16px" height="16px"
                      alt="Total" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{totalVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Total
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container" (click)="overAllGetDetails('YET_TO_BE_ATTEMPTED')"
              (keydown.enter)="overAllGetDetails('YET_TO_BE_ATTEMPTED')">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu pending_request">
                    <img src="../../../assets/img/tms/yet.svg" width="16px" height="16px" alt="Yet To Be Attempted" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{yetToBeAttemptedVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Yet To Be
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container" (click)="overAllGetDetails('ATTEMPTED')"
              (keydown.enter)="overAllGetDetails('ATTEMPTED')">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu closed_request">
                    <img src="../../../assets/img/tms/att.svg" width="16px" height="16px" alt="Attempted" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{attemptedVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Attempted
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container" (click)="overAllGetDetails('COMPLETED_AT_ATTEMPTED_CHART')"
              (keydown.enter)="overAllGetDetails('COMPLETED_AT_ATTEMPTED_CHART')">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu active_request">
                    <img src="../../../assets/img/tms/pass.svg" width="16px" height="16px"
                      alt="Completed At Attempted" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{completedAtAttemptedVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Completed
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container" (click)="overAllGetDetails('FAILED_AT_ATTEMPTED_CHART')"
              (keydown.enter)="overAllGetDetails('FAILED_AT_ATTEMPTED_CHART')">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu overdue_request">
                    <img src="../../../assets/img/tms/fail.svg" width="16px" height="16px" alt="Failed At Attempted" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{failedAtAttemptedChartVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Failed
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container" (click)="overAllGetDetails('SCHEDULED_AT_ATTEMPTED_CHART')"
              (keydown.enter)="overAllGetDetails('SCHEDULED_AT_ATTEMPTED_CHART')">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu other_request">
                    <img src="../../../assets/img/tms/sch.svg" width="16px" height="16px"
                      alt="Scheduled At Attempted" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{scheduledAtAttemptedChartVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Scheduled
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container" style="cursor: default;">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu my_total_request">
                    <img src="../../../assets/img/tms/per.svg" width="16px" height="16px" alt="%" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{passPerValForAll}} %
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Pass
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="table-container">
          <div class="table-header">
            <div class="table-cell-th name" style="min-width: 250px;"
              *ngIf="selectedOption=='Users' || selectedOption=='Team Member Trainings' || selectedOption=='Organization'">
              User Name</div>
            <div class="table-cell-th name" *ngIf="selectedOption=='Department'">Department</div>
            <div class="table-cell-th name" style="min-width: 250px;" *ngIf="selectedOption=='Training Groups'">User
              Name</div>
            <div class="table-cell-th name" style="min-width: 250px;"
              *ngIf="selectedOption=='Trainings' || selectedOption=='Instructor Trainings'">Training Name
            </div>
            <div class="table-cell-th" *ngIf="selectedOption=='Trainings' ">Version</div>
            <div class="table-cell-th " *ngIf=" selectedOption=='Instructor Trainings'">Version</div>
            <div class="table-cell-th">Total</div>
            <div class="table-cell-th">Yet To Be Attempted</div>
            <div class="table-cell-th">Attempted</div>
            <div class="table-cell-th">Completed</div>
            <div class="table-cell-th">Failed</div>
            <div class="table-cell-th">Scheduled</div>
            <div class="table-cell-th">Failed Attempts</div>
            <div class="table-cell-th">Pass %</div>
          </div>
          <div class="table-row" *ngFor="let listOfUsersData of pagedItemsMain; let idx = index;">
            <div class="table-cell2 name clickable nameAlign"
              *ngIf="selectedOption=='Users' || selectedOption=='Team Member Trainings' || selectedOption=='Organization'"
              style="min-width: 250px;" (click)="getDetails(idx,'All')" (keydown.enter)="getDetails(idx,'All')"
              [title]="listOfUsersData.usrFullname">
              {{listOfUsersData.usrFullname}}
            </div>
            <div class="table-cell name clickable nameAlign" *ngIf="selectedOption=='Training Groups'"
              style="min-width: 250px;" (click)="getDetails(idx,'All')" (keydown.enter)="getDetails(idx,'All')"
              [title]="listOfUsersData.userName">
              {{listOfUsersData.userName}}
            </div>
            <div class="table-cell name clickable nameAlign" *ngIf="selectedOption=='Department'"
              (click)="getDetails(idx,'All')" (keydown.enter)="getDetails(idx,'All')">
              {{listOfUsersData.departmentCode}}
            </div>
            <div class="table-cell name clickable nameAlign" style="min-width: 250px;"
              *ngIf="selectedOption=='Trainings' || selectedOption=='Instructor Trainings'"
              (click)="getDetails(idx,'All')" (keydown.enter)="getDetails(idx,'All')"
              [title]="listOfUsersData.trainingName">
              {{listOfUsersData.trainingName}}
            </div>
            <div class="table-cell  clickable valueAlign"
              *ngIf="selectedOption=='Trainings' || selectedOption=='Instructor Trainings'">
              {{listOfUsersData.version}}
            </div>
            <div class="table-cell clickable valueAlign" (click)="getDetails(idx,'All')"
              (keydown.enter)="getDetails(idx,'All')">
              {{listOfUsersData.total}}
            </div>
            <div class="table-cell clickable valueAlign" (click)="getDetails(idx,'YET_TO_BE_ATTEMPTED')"
              (keydown.enter)="getDetails(idx,'YET_TO_BE_ATTEMPTED')">
              {{listOfUsersData.yetToBeAttempted}}
            </div>
            <div class="table-cell clickable valueAlign" (click)="getDetails(idx,'ATTEMPTED')"
              (keydown.enter)="getDetails(idx,'ATTEMPTED')">
              {{listOfUsersData.attempted}}
            </div>
            <div class="table-cell clickable valueAlign" (click)="getDetails(idx,'COMPLETED_AT_ATTEMPTED_CHART')"
              (keydown.enter)="getDetails(idx,'COMPLETED_AT_ATTEMPTED_CHART')">
              {{listOfUsersData.completedAtAttemptedChart}}
            </div>
            <div class="table-cell clickable valueAlign" (click)="getDetails(idx,'FAILED_AT_ATTEMPTED_CHART')"
              (keydown.enter)="getDetails(idx,'FAILED_AT_ATTEMPTED_CHART')">
              {{listOfUsersData.failedAtAttemptedChart}}
            </div>
            <div class="table-cell clickable valueAlign" (click)="getDetails(idx,'SCHEDULED_AT_ATTEMPTED_CHART')"
              (keydown.enter)="getDetails(idx,'SCHEDULED_AT_ATTEMPTED_CHART')">
              {{listOfUsersData.scheduledAtAttemptedChart}}
            </div>
            <div class="table-cell valueAlign">
              {{listOfUsersData.failedAttempts}}
            </div>
            <div class="table-cell valueAlign">
              {{(listOfUsersData.completed / listOfUsersData.total * 100).toFixed(1)}}%
            </div>
          </div>
        </div>

        <div *ngIf="collectionSize>10">
          <div class="row border-top mt-1 width-cheat small paginationCell">
            <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
            </nav>
            <div class="col-2 col-md-6 d-flex justify-content-end align-items-center">
            </div>
            <nav class="col-6 col-md-4 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">

              1-{{ perPage }} of {{ collectionSize | number }}
              <ngb-pagination class="leftpadding" (pageChange)="setPageMain(pager.currentPage,$event)"
                [disabled]="false" [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize"
                [rotate]="true" [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
              </ngb-pagination>
              <div ngbDropdown class="d-inline-block leftpadding">
                <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
                  {{perPage}}
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                  <button ngbDropdownItem (click)="paginationCallMain(10)">10</button>
                  <button ngbDropdownItem (click)="paginationCallMain(20)">20</button>
                  <button ngbDropdownItem (click)="paginationCallMain(50)">50</button>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
      <div class="col-md-9" *ngIf="notCompleted && selectedOption == 'Organization'">
        <div class="panel">
          <div class="detail-menu-container">
            <div class="mini-chart-container1">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu">
                    <img src="../../../assets/img/cr_module/total_requests.svg" width="16px" height="16px"
                      alt="Total" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{totalVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Total
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container1">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu pending_request">
                    <img src="../../../assets/img/tms/yet.svg" width="16px" height="16px" alt="Pending" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{pendingVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Pending
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container1">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu active_request">
                    <img src="../../../assets/img/tms/pass.svg" width="16px" height="16px" alt="Completed" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{completedVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Completed
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container1">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu overdue_request">
                    <img src="../../../assets/img/tms/fail.svg" width="16px" height="16px" alt="Failed" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{failedVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Failed
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container1">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu other_request">
                    <img src="../../../assets/img/tms/sch.svg" width="16px" height="16px" alt="Scheduled" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{scheduledVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Scheduled
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container1">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu inpro_request">
                    <img src="../../../assets/img/processing-time.png" width="16px" height="16px" alt="Inprogress" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{inprogressVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Inprogress
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container1">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu over_request">
                    <img src="../../../assets/img/time.png" width="16px" height="16px" alt="Overdue" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{overdueVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Overdue
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container1">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu lock_request">
                    <img src="../../../assets/img/padlock (1).png" width="16px" height="16px" alt="Locked" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{lockedVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Locked
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container1" style="cursor: default;">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu my_total_request">
                    <img src="../../../assets/img/tms/per.svg" width="16px" height="16px" alt="%" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{passPerVal}} %
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Pass
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="table-container">
          <div class="table-header1">
            <div class="table-cell-th1 name">Organization Name</div>
            <div class="table-cell-th1">No. Of Users</div>
            <div class="table-cell-th1">No. Of Individual Trainings</div>
            <div class="table-cell-th1">Total</div>
            <div class="table-cell-th1">Pending</div>
            <div class="table-cell-th1" style="font-size: 9px;">Completed</div>
            <div class="table-cell-th1">Failed</div>
            <div class="table-cell-th1">Scheduled</div>
            <div class="table-cell-th1">Inprogress</div>
            <div class="table-cell-th1">Overdue</div>
            <div class="table-cell-th1">Locked</div>
            <div class="table-cell-th1">Failed Attempts</div>
            <div class="table-cell-th1">Pass %</div>
          </div>
          <div class="table-row1" *ngFor="let listOfUsersData of pagedItemsMain; let idx = index;">
            <div class="table-cell1 name clickable nameAlign" (click)="getDetailsOrg(listOfUsersData)"
              (keydown.enter)="getDetailsOrg(listOfUsersData)">
              {{listOfUsersData.orgName}}
            </div>
            <div class="table-cell1 clickable valueAlign" (click)="getDetailsOrgUsers(listOfUsersData)"
              (keydown.enter)="getDetailsOrgUsers(listOfUsersData)">
              {{listOfUsersData.noOfUsers}}
            </div>
            <div class="table-cell1 clickable valueAlign" (click)="getDetailsOrgTrainings(listOfUsersData)"
              (keydown.enter)="getDetailsOrgTrainings(listOfUsersData)">
              {{listOfUsersData.noOfIndividualTrainings}}
            </div>
            <div class="table-cell1 clickable valueAlign" (click)="getDetailsOrg(listOfUsersData)"
              (keydown.enter)="getDetailsOrg(listOfUsersData)">
              {{listOfUsersData.total}}
            </div>
            <div class="table-cell1 valueAlign">
              {{listOfUsersData.pending}}
            </div>
            <div class="table-cell1 valueAlign">
              {{listOfUsersData.completed}}
            </div>
            <div class="table-cell1 valueAlign">
              {{listOfUsersData.failed}}
            </div>
            <div class="table-cell1 valueAlign">
              {{listOfUsersData.scheduled}}
            </div>
            <div class="table-cell1 valueAlign">
              {{listOfUsersData.inprogress}}
            </div>
            <div class="table-cell1 clickable valueAlign">
              {{listOfUsersData.overdue}}
            </div>
            <div class="table-cell1 valueAlign">
              {{listOfUsersData.locked}}
            </div>
            <div class="table-cell1 valueAlign">
              {{listOfUsersData.failedAttempts}}
            </div>
            <div class="table-cell1 valueAlign">
              {{(listOfUsersData.completed / listOfUsersData.total * 100).toFixed(1)}}%
            </div>
          </div>
        </div>
        <div *ngIf="collectionSize>10">
          <div class="row border-top mt-1 width-cheat small paginationCell">
            <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
            </nav>
            <div class="col-2 col-md-6 d-flex justify-content-end align-items-center">
            </div>
            <nav class="col-6 col-md-4 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
              1-{{ perPage }} of {{ collectionSize | number }}
              <ngb-pagination class="leftpadding" (pageChange)="setPageMain(pager.currentPage,$event)"
                [disabled]="false" [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize"
                [rotate]="true" [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
              </ngb-pagination>
              <div ngbDropdown class="d-inline-block leftpadding">
                <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
                  {{perPage}}
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                  <button ngbDropdownItem (click)="paginationCallMain(10)">10</button>
                  <button ngbDropdownItem (click)="paginationCallMain(20)">20</button>
                  <button ngbDropdownItem (click)="paginationCallMain(50)">50</button>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
      <div class="col-md-9" *ngIf="!notCompleted && selectedOption == 'Organization'">
        <div class="panel">
          <div class="detail-menu-container">
            <div class="mini-chart-container" style="cursor: default;">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu">
                    <img src="../../../assets/img/cr_module/total_requests.svg" width="16px" height="16px"
                      alt="Total" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{totalVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Total
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container" style="cursor: default;">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu pending_request">
                    <img src="../../../assets/img/tms/yet.svg" width="16px" height="16px" alt="Yet To Be Attempted" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{yetToBeAttemptedVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Yet To Be
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container" style="cursor: default;">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu closed_request">
                    <img src="../../../assets/img/tms/att.svg" width="16px" height="16px" alt="Attempted" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{attemptedVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Attempted
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container" style="cursor: default;">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu active_request">
                    <img src="../../../assets/img/tms/pass.svg" width="16px" height="16px"
                      alt="Completed At Attempted" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{completedAtAttemptedVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Completed
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container" style="cursor: default;">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu overdue_request">
                    <img src="../../../assets/img/tms/fail.svg" width="16px" height="16px" alt="Failed At Attempted" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{failedAtAttemptedChartVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Failed
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container" style="cursor: default;">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu other_request">
                    <img src="../../../assets/img/tms/sch.svg" width="16px" height="16px"
                      alt="Scheduled At Attempted" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{scheduledAtAttemptedChartVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Scheduled
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container" style="cursor: default;">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu my_total_request">
                    <img src="../../../assets/img/tms/per.svg" width="16px" height="16px" alt="%" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{passPerValForAll}} %
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Pass
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="table-container">
          <div class="table-header">
            <div class="table-cell-th name">Organization Name</div>
            <div class="table-cell-th">No. Of Users</div>
            <div class="table-cell-th">No. Of Individual Trainings</div>
            <div class="table-cell-th">Total</div>
            <div class="table-cell-th">Yet To Be Attempted</div>
            <div class="table-cell-th">Attempted</div>
            <div class="table-cell-th">Completed</div>
            <div class="table-cell-th">Failed</div>
            <div class="table-cell-th">Scheduled</div>
            <div class="table-cell-th">Failed Attempts</div>
            <div class="table-cell-th">Pass %</div>
          </div>
          <div class="table-row" *ngFor="let listOfUsersData of pagedItemsMain; let idx = index;">
            <div class="table-cell name clickable nameAlign" [title]="listOfUsersData.orgName"
              (click)="getDetailsOrg(listOfUsersData)" (keydown.enter)="getDetailsOrg(listOfUsersData)">
              {{listOfUsersData.orgName}}
            </div>
            <div class="table-cell clickable valueAlign" (click)="getDetailsOrgUsers(listOfUsersData)"
              (keydown.enter)="getDetailsOrgUsers(listOfUsersData)">
              {{listOfUsersData.noOfUsers}}
            </div>
            <div class="table-cell clickable valueAlign" (click)="getDetailsOrgTrainings(listOfUsersData)"
              (keydown.enter)="getDetailsOrgTrainings(listOfUsersData)">
              {{listOfUsersData.noOfIndividualTrainings}}
            </div>
            <div class="table-cell clickable valueAlign" (click)="getDetailsOrg(listOfUsersData)"
              (keydown.enter)="getDetailsOrg(listOfUsersData)">
              {{listOfUsersData.total}}
            </div>
            <div class="table-cell valueAlign">
              {{listOfUsersData.yetToBeAttempted}}
            </div>
            <div class="table-cell valueAlign">
              {{listOfUsersData.attempted}}
            </div>
            <div class="table-cell valueAlign">
              {{listOfUsersData.completedAtAttemptedChart}}
            </div>
            <div class="table-cell valueAlign">
              {{listOfUsersData.failedAtAttemptedChart}}
            </div>
            <div class="table-cell valueAlign">
              {{listOfUsersData.scheduledAtAttemptedChart}}
            </div>
            <div class="table-cell valueAlign">
              {{listOfUsersData.failedAttempts}}
            </div>
            <div class="table-cell valueAlign">
              {{(listOfUsersData.completed / listOfUsersData.total * 100).toFixed(1)}}%
            </div>
          </div>
        </div>

        <div *ngIf="collectionSize>10">
          <div class="row border-top mt-1 width-cheat small paginationCell">
            <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
            </nav>
            <div class="col-2 col-md-6 d-flex justify-content-end align-items-center">
            </div>
            <nav class="col-6 col-md-4 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">

              1-{{ perPage }} of {{ collectionSize | number }}
              <ngb-pagination class="leftpadding" (pageChange)="setPageMain(pager.currentPage,$event)"
                [disabled]="false" [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize"
                [rotate]="true" [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
              </ngb-pagination>
              <div ngbDropdown class="d-inline-block leftpadding">
                <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
                  {{perPage}}
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                  <button ngbDropdownItem (click)="paginationCallMain(10)">10</button>
                  <button ngbDropdownItem (click)="paginationCallMain(20)">20</button>
                  <button ngbDropdownItem (click)="paginationCallMain(50)">50</button>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div id="chartContainerTMS" style="height: 250px; width: 100%;"></div>
      </div>
      <div class="col-md-12"
        *ngIf="selectedOption == 'Organization' && getOneQmsUsersTrainingsRepVwTrainingCountByOr.length>0">
        <div class="menu-container">
          <div class="row menu-row-container">
            <div class="col-sm-6 gridName-container">
              <span class="tms-reports_title">No. Of Individual Trainings</span>
            </div>
            <div class="col-sm-5 action-buttons-container" style="margin-left: 59%;margin-top: -27px;">
              <div (click)="openReportPopupOrgMain('training')" (keydown.enter)="openReportPopupOrgMain('training')">
                <i class="fa fa-file-excel-o" style="font-size:18px;color:bule"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="table-container">
          <div class="table-header">
            <div class="table-cell-th name">Organization Name</div>
            <div class="table-cell-th name">Training Name</div>
            <div class="table-cell-th">Version</div>
            <div class="table-cell-th">Total</div>
            <div class="table-cell-th">Yet To Be Attempted</div>
            <div class="table-cell-th">Attempted</div>
            <div class="table-cell-th">Completed</div>
            <div class="table-cell-th">Failed</div>
            <div class="table-cell-th">Scheduled</div>
            <div class="table-cell-th">Failed Attempts</div>
            <div class="table-cell-th">Pass %</div>
          </div>
          <div class="table-row" *ngFor="let listOfUsersData of pagedItems3rd; let idx = index;">
            <div class="table-cell name nameAlign">
              {{listOfUsersData.orgName}}
            </div>
            <div class="table-cell clickable nameAlign" [title]="listOfUsersData.trainingName"
              (click)="getDetailsOrgTraining(listOfUsersData,'All','training')"
              (keydown.enter)="getDetailsOrgTraining(listOfUsersData,'All','training')">
              {{listOfUsersData.trainingName}}
            </div>
            <div class="table-cell valueAlign">
              {{listOfUsersData.version}}
            </div>

            <div class="table-cell clickable valueAlign"
              (click)="getDetailsOrgTraining(listOfUsersData,'All','training')"
              (keydown.enter)="getDetailsOrgTraining(listOfUsersData,'All','training')">
              {{listOfUsersData.total}}
            </div>
            <div class="table-cell valueAlign"
              (click)="getDetailsOrgTraining(listOfUsersData,'YET_TO_BE_ATTEMPTED','training')"
              (keydown.enter)="getDetailsOrgTraining(listOfUsersData,'YET_TO_BE_ATTEMPTED','training')">
              {{listOfUsersData.yetToBeAttempted}}
            </div>
            <div class="table-cell valueAlign" (click)="getDetailsOrgTraining(listOfUsersData,'ATTEMPTED','training')"
              (keydown.enter)="getDetailsOrgTraining(listOfUsersData,'ATTEMPTED','training')">
              {{listOfUsersData.attempted}}
            </div>
            <div class="table-cell valueAlign"
              (click)="getDetailsOrgTraining(listOfUsersData,'COMPLETED_AT_ATTEMPTED_CHART','training')"
              (keydown.enter)="getDetailsOrgTraining(listOfUsersData,'COMPLETED_AT_ATTEMPTED_CHART','training')">
              {{listOfUsersData.completedAtAttemptedChart}}
            </div>
            <div class="table-cell valueAlign"
              (click)="getDetailsOrgTraining(listOfUsersData,'FAILED_AT_ATTEMPTED_CHART','training')"
              (keydown.enter)="getDetailsOrgTraining(listOfUsersData,'FAILED_AT_ATTEMPTED_CHART','training')">
              {{listOfUsersData.failedAtAttemptedChart}}
            </div>
            <div class="table-cell valueAlign"
              (click)="getDetailsOrgTraining(listOfUsersData,'SCHEDULED_AT_ATTEMPTED_CHART','training')"
              (keydown.enter)="getDetailsOrgTraining(listOfUsersData,'SCHEDULED_AT_ATTEMPTED_CHART','training')">
              {{listOfUsersData.scheduledAtAttemptedChart}}
            </div>
            <div class="table-cell valueAlign">
              {{listOfUsersData.failedAttempts}}
            </div>
            <div class="table-cell valueAlign">
              {{(listOfUsersData.completed / listOfUsersData.total * 100).toFixed(1)}}%
            </div>
          </div>
        </div>

        <div *ngIf="collectionSize3rd>10">
          <div class="row border-top mt-1 width-cheat small paginationCell">
            <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
            </nav>
            <div class="col-2 col-md-6 d-flex justify-content-end align-items-center">
            </div>
            <nav class="col-6 col-md-4 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">

              1-{{ perPage3rd }} of {{ collectionSize3rd | number }}
              <ngb-pagination class="leftpadding" (pageChange)="setPage3rd(pager3rd.currentPage,$event)"
                [disabled]="false" [collectionSize]="pager3rd.totalItems" [(page)]="pager3rd.currentPage"
                [maxSize]="maxSize" [rotate]="true" [pageSize]="perPage3rd" [ellipses]="false" [boundaryLinks]="true"
                size="sm">
              </ngb-pagination>
              <div ngbDropdown class="d-inline-block leftpadding">
                <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
                  {{perPage3rd}}
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                  <button ngbDropdownItem (click)="paginationCall3rd(10)">10</button>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
      <div class="col-md-12"
        *ngIf="selectedOption == 'Organization' && getOneQmsUsersTrainingsRepVwUserCountByor.length>0">
        <div class="menu-container">
          <div class="row menu-row-container">
            <div class="col-sm-6 gridName-container">
              <span class="tms-reports_title">No. Of Users</span>
            </div>
            <div class="col-sm-5 action-buttons-container" style="margin-left: 59%;margin-top: -27px;">
              <div (click)="openReportPopupOrgMain('user')" (keydown.enter)="openReportPopupOrgMain('user')">
                <i class="fa fa-file-excel-o" style="font-size:18px;color:bule"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="table-container">
          <div class="table-header">
            <div class="table-cell-th name" style="min-width: 250px;">User Name</div>
            <div class="table-cell-th">Total</div>
            <div class="table-cell-th">Yet To Be Attempted</div>
            <div class="table-cell-th">Attempted</div>
            <div class="table-cell-th">Completed</div>
            <div class="table-cell-th">Failed</div>
            <div class="table-cell-th">Scheduled</div>
            <div class="table-cell-th">Failed Attempts</div>
            <div class="table-cell-th">Pass %</div>
          </div>
          <div class="table-row" *ngFor="let listOfUsersData of pagedItems4th; let idx = index;">
            <div class="table-cell clickable nameAlign" style="min-width: 250px;"
              (click)="getDetailsOrgTraining(listOfUsersData,'All','users')"
              (keydown.enter)="getDetailsOrgTraining(listOfUsersData,'All','users')"
              [title]="listOfUsersData.usrFullname">
              {{listOfUsersData.usrFullname}}
            </div>
            <div class="table-cell clickable valueAlign" (click)="getDetailsOrgTraining(listOfUsersData,'All','users')"
              (keydown.enter)="getDetailsOrgTraining(listOfUsersData,'All','users')">
              {{listOfUsersData.total}}
            </div>
            <div class="table-cell valueAlign"
              (click)="getDetailsOrgTraining(listOfUsersData,'YET_TO_BE_ATTEMPTED','users')"
              (keydown.enter)="getDetailsOrgTraining(listOfUsersData,'YET_TO_BE_ATTEMPTED','users')">
              {{listOfUsersData.yetToBeAttempted}}
            </div>
            <div class="table-cell valueAlign" (click)="getDetailsOrgTraining(listOfUsersData,'ATTEMPTED','users')"
              (keydown.enter)="getDetailsOrgTraining(listOfUsersData,'ATTEMPTED','users')">
              {{listOfUsersData.attempted}}
            </div>
            <div class="table-cell valueAlign"
              (click)="getDetailsOrgTraining(listOfUsersData,'COMPLETED_AT_ATTEMPTED_CHART','users')"
              (keydown.enter)="getDetailsOrgTraining(listOfUsersData,'COMPLETED_AT_ATTEMPTED_CHART','users')">
              {{listOfUsersData.completedAtAttemptedChart}}
            </div>
            <div class="table-cell valueAlign"
              (click)="getDetailsOrgTraining(listOfUsersData,'FAILED_AT_ATTEMPTED_CHART','users')"
              (keydown.enter)="getDetailsOrgTraining(listOfUsersData,'FAILED_AT_ATTEMPTED_CHART','users')">
              {{listOfUsersData.failedAtAttemptedChart}}
            </div>
            <div class="table-cell valueAlign"
              (click)="getDetailsOrgTraining(listOfUsersData,'SCHEDULED_AT_ATTEMPTED_CHART','users')"
              (keydown.enter)="getDetailsOrgTraining(listOfUsersData,'SCHEDULED_AT_ATTEMPTED_CHART','users')">
              {{listOfUsersData.scheduledAtAttemptedChart}}
            </div>
            <div class="table-cell valueAlign">
              {{listOfUsersData.failedAttempts}}
            </div>
            <div class="table-cell valueAlign">
              {{(listOfUsersData.completed / listOfUsersData.total * 100).toFixed(1)}}%
            </div>
          </div>
        </div>
        <div *ngIf="collectionSize4th>10">
          <div class="row border-top mt-1 width-cheat small paginationCell">
            <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
            </nav>
            <div class="col-2 col-md-6 d-flex justify-content-end align-items-center">
            </div>
            <nav class="col-6 col-md-4 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
              1-{{ perPage4th }} of {{ collectionSize4th | number }}
              <ngb-pagination class="leftpadding" (pageChange)="setPage4th(pager4th.currentPage,$event)"
                [disabled]="false" [collectionSize]="pager4th.totalItems" [(page)]="pager4th.currentPage"
                [maxSize]="maxSize" [rotate]="true" [pageSize]="perPage4th" [ellipses]="false" [boundaryLinks]="true"
                size="sm">
              </ngb-pagination>
              <div ngbDropdown class="d-inline-block leftpadding">
                <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
                  {{perPage4th}}
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                  <button ngbDropdownItem (click)="paginationCall4th(10)">10</button>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--main grid end-->
  <!-- details grid -->
  <br>
  <div class="table-container" *ngIf="totalVal == 0 " style="margin-top:10px">
    <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold;font-size: 24px;">
      <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 275px; height: 200px;"> </span>
  </div>
  <div class="row table-container" style="margin-top:30px;" *ngIf="tmsUserTrainingsRepVwDataForGrid.length>0">
    <div class="menu-container">
      <div class="row menu-row-container">
        <div class="col-sm-6 gridName-container">
          <span class="tms-reports_title" title="{{selectedStatus}}">{{selectedStatus.length > 50 ? (selectedStatus |
            slice:0:50) + '...' : selectedStatus}}</span>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="panel">
        <div class="panel-body cetmf-panel-body" style="padding: 3px;">
          <div class="row" *ngIf="message.showRetakeAndMarkasCompleted ">
            <div class="col-4">
              <div class="row" *ngIf="message.showRetakeAndMarkasCompleted && pagedItemsSecond.length>0">
                <div class="col-4 addIconContiner d-flex gap-2 justify-content-center align-items-center"
                  (click)="markAsCompleted()" (keydown.enter)="markAsCompleted()" matTooltip="Mark as Completed">
                  <img src="../../assets/img/tms/mark.svg" alt=" " style="color: black;background-color:white;">
                  <span class="reload_text text-white"> Mark as Completed</span>
                </div>
                <div class="col-4 addIconContiner d-flex gap-2 justify-content-center align-items-center"
                  style="color: black;background-color:white;" (click)="retackTrainings()"
                  matTooltip="Re-Assign Trainings">
                  <img src="../../assets/img/tms/reassign.svg" alt=" " style="font-size:18px;">
                  <span class="reload_text">Re-Assign Trainings</span>
                </div>
                <div class="col-4 addIconContiner d-flex gap-2 justify-content-center align-items-center"
                  style="color: black;background-color:white;" (click)="removeUserTrining()"
                  (keydown.enter)="removeUserTrining()" matTooltip="Remove Trainings">
                  <img src="../../assets/img/tms/delete.svg" alt=" " style="font-size:18px;">
                  <span class="reload_text">Remove Trainings</span>
                </div>
              </div>
            </div>
            <div class="col-2" *ngIf="!showOnlyConsider"></div>
            <div class="col-2"
              *ngIf="(pagedItemsSecond.length>0 || showOnlyConsider) && this.message.showRetakeAndMarkasCompleted">
              <div>
                <label for="email" id="notCondiderForReport"><b>Not Consider For Report</b></label>
                <mat-slide-toggle color="primary" [(ngModel)]="showOnlyConsider"
                  (change)="showOnlyNotConsiderRtp($event)">
                  <span class="active-inActive-container" *ngIf="showOnlyConsider" style="color: green;">Yes</span>
                  <span *ngIf="!showOnlyConsider" style="color: red;">No</span>
                </mat-slide-toggle>
              </div>
            </div>
            <div class="col-2" *ngIf="showOnlyConsider">
              <mat-select matInput placeholder="Select" [(ngModel)]="searchByReson" (closed)="resonSearchText=''"
                (click)="focusSearch('focus-title-search1')" (keydown.enter)="focusSearch('focus-title-search1')">
                <input type="search" id="focus-title-search1" class="dropdownsearchstyle" [(ngModel)]="resonSearchText"
                  matInput placeholder="Reson">
                <mat-option class="unselectStyle" [value]="null"
                  (onSelectionChange)="resonSelect($event,null);">Un-select</mat-option>
                <mat-option *ngFor="let item of resonForNotConsiderDropdown | assessmentSearch : resonSearchText;"
                  (onSelectionChange)="resonSelect($event,item)" [value]="item.valueExp">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
            </div>
            <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
              (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
              <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
              <span class="reload_text text-white">Excel Report</span>
            </div>
            <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
              (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
              <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
              <span class="reload_text text-white">PDF Report</span>
            </div>

          </div>

          <div class="row" *ngIf="!message.showRetakeAndMarkasCompleted && pagedItemsSecond.length>0">
            <div class="col-6"></div>

            <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center col-2"
              *ngIf="message.dataGridAdmin" (click)="openReorder()" (keydown.enter)="openReorder()">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="#ffffff">
                <path style="fill:'#FFFFFF'"
                  d="M10 6.66666C10.8841 6.66666 11.7319 7.01785 12.357 7.64297C12.9822 8.2681 13.3333 9.11594 13.3333 10C13.3333 10.8841 12.9822 11.7319 12.357 12.357C11.7319 12.9821 10.8841 13.3333 10 13.3333C9.11596 13.3333 8.26811 12.9821 7.64299 12.357C7.01787 11.7319 6.66668 10.8841 6.66668 10C6.66668 9.11594 7.01787 8.2681 7.64299 7.64297C8.26811 7.01785 9.11596 6.66666 10 6.66666ZM10 8.33333C9.55799 8.33333 9.13406 8.50893 8.8215 8.82149C8.50894 9.13405 8.33335 9.55797 8.33335 10C8.33335 10.442 8.50894 10.8659 8.8215 11.1785C9.13406 11.4911 9.55799 11.6667 10 11.6667C10.442 11.6667 10.866 11.4911 11.1785 11.1785C11.4911 10.8659 11.6667 10.442 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.866 8.50893 10.442 8.33333 10 8.33333ZM8.33335 18.3333C8.12501 18.3333 7.95001 18.1833 7.91668 17.9833L7.60835 15.775C7.08335 15.5667 6.63335 15.2833 6.20001 14.95L4.12501 15.7917C3.94168 15.8583 3.71668 15.7917 3.61668 15.6083L1.95001 12.725C1.89901 12.6391 1.88103 12.5376 1.89943 12.4395C1.91784 12.3413 1.97137 12.2532 2.05001 12.1917L3.80835 10.8083L3.75001 10L3.80835 9.16666L2.05001 7.80833C1.97137 7.74678 1.91784 7.65868 1.89943 7.56052C1.88103 7.46236 1.89901 7.36086 1.95001 7.275L3.61668 4.39166C3.71668 4.20833 3.94168 4.13333 4.12501 4.20833L6.20001 5.04166C6.63335 4.71666 7.08335 4.43333 7.60835 4.225L7.91668 2.01666C7.95001 1.81666 8.12501 1.66666 8.33335 1.66666H11.6667C11.875 1.66666 12.05 1.81666 12.0833 2.01666L12.3917 4.225C12.9167 4.43333 13.3667 4.71666 13.8 5.04166L15.875 4.20833C16.0583 4.13333 16.2833 4.20833 16.3833 4.39166L18.05 7.275C18.1583 7.45833 18.1084 7.68333 17.95 7.80833L16.1917 9.16666L16.25 10L16.1917 10.8333L17.95 12.1917C18.1084 12.3167 18.1583 12.5417 18.05 12.725L16.3833 15.6083C16.2833 15.7917 16.0583 15.8667 15.875 15.7917L13.8 14.9583C13.3667 15.2833 12.9167 15.5667 12.3917 15.775L12.0833 17.9833C12.05 18.1833 11.875 18.3333 11.6667 18.3333H8.33335ZM9.37501 3.33333L9.06668 5.50833C8.06668 5.71666 7.18335 6.25 6.54168 6.99166L4.53335 6.125L3.90835 7.20833L5.66668 8.5C5.33335 9.47222 5.33335 10.5278 5.66668 11.5L3.90001 12.8L4.52501 13.8833L6.55001 13.0167C7.19168 13.75 8.06668 14.2833 9.05835 14.4833L9.36668 16.6667H10.6333L10.9417 14.4917C11.9333 14.2833 12.8083 13.75 13.45 13.0167L15.475 13.8833L16.1 12.8L14.3333 11.5083C14.6667 10.5333 14.6667 9.475 14.3333 8.5L16.0917 7.20833L15.4667 6.125L13.4583 6.99166C12.8035 6.2336 11.9153 5.71473 10.9333 5.51666L10.625 3.33333H9.37501Z" />
              </svg>
              <span class="reload_text text-white">Settings</span>
            </div>
            <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
              (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
              <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
              <span class="reload_text text-white">Excel Report</span>
            </div>
            <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
              (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
              <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
              <span class="reload_text text-white">PDF Report</span>
            </div>
          </div>
          &nbsp;&nbsp;
          <div class="table-container">
            <table style="height: 60vh;">
              <thead>
                <th>
                  <input type="checkbox" style="zoom: 1.2;  width: 35px;" [(ngModel)]="selectAllChecked"
                    (change)="selectAllRows()" />
                </th>

                <th id="grid-header-container"
                  *ngFor="let oneQmsUsersDataForTable1Data of columnLists.fieldColumnarray; let ix = index;"
                  [ngStyle]="{'min-width': oneQmsUsersDataForTable1Data.width}"
                  class="sticky-dynamic-col1 dynamic-table-header-style">
                  <div *ngIf="oneQmsUsersDataForTable1Data.fieldColumnarray != 'Prim Identifier'">
                    <span>{{oneQmsUsersDataForTable1Data.fieldColumnarray}}</span>
                    <div class="row-search-container">
                      <input type="text" class="form-control" placeholder="Search"
                        (input)="applyFilter(columnLists.columnsListarray[ix],$event,'s')">
                    </div>
                  </div>
                </th>
              </thead>
              <tr *ngIf="pagedItemsSecond.length === 0">
                <td class="row-data text-center" colspan="15">No records found</td>
              </tr>
              <tr *ngFor="let list of pagedItemsSecond  | searchFilter : searchValue; let idx = index;">
                <td>
                  <input type="checkbox" style="zoom: 1.2; width: 35px; " [(ngModel)]="list.isSelected"
                    (change)="childCheckboxChanged()" />
                </td>
                <td id="grid-row-container" *ngFor="let key of columnLists.columnsListarray1; let i = index;"
                  class="sticky-dynamic-row1" [ngStyle]="{'min-width': key.width[i],'max-width': key.width[i],'overflow': 'hidden',
                  'text-overflow': 'ellipsis',
                  'white-space': 'nowrap'}" [ngClass]="{'hidden-column': key.columnsListarray === 'PRIM_IDENTIFIER'}">
                  <span *ngIf="key.dataType=='CHECKBOX'">
                    <div class="gridCheckBoxes">
                      <img *ngIf="list[key.columnsListarray]" alt="" src="../../assets/img/accessSymbol.svg" width="20"
                        height="20">
                      <img *ngIf="list[key.columnsListarray]==false" src="../../assets/img/noAcessSymbol.svg" width="20"
                        height="20" alt="">
                    </div>
                  </span>
                  <span *ngIf="list[key.columnsListarray]=='htmlClobView'">
                    <div class="download-button-continer btn-align" mat-dialog-actions>
                      <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                        (click)="getClobData(list,key.columnsListarray)">
                        <img src="../../../assets/img/view.png" width="12px" height="12px" alt="download">
                        <span class="ms-1" style="color:azure">View</span>
                      </button>
                    </div>
                  </span>
                  <span
                    *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE' && list[key.columnsListarray] !='htmlClobView' && list[key.columnsListarray] !='fileIspresentsa' && list[key.columnsListarray] !='fileIsNotpresentsa' "
                    [matTooltip]="list[key.columnsListarray]">{{
                    list[key.columnsListarray]}}</span>
                  <span *ngIf="key.dataType=='DATE' && key.columnsListarray=='EFFECTIVE_DATE'">{{
                    list[key.columnsListarray] |
                    date : (appService.getOneQmsDateFormat + ' HH:mm:ss')}}</span>
                  <span *ngIf="key.dataType=='DATE'&& key.columnsListarray=='EXPIRATION_DATE'">{{
                    list[key.columnsListarray] |
                    date : (appService.getOneQmsDateFormat + ' HH:mm:ss')}}</span>
                  <span
                    *ngIf="key.dataType=='DATE'&& key.columnsListarray!='EFFECTIVE_DATE' && key.columnsListarray!='EXPIRATION_DATE'">{{
                    list[key.columnsListarray] }}</span>
                </td>
                <td class="sticky-col first-col">
                  <div class="action-icons">
                    <i class="fas fa-download" title="Certificate Download" style="margin-left: 5px;"
                      *ngIf="list['STATUS']=='Completed'" (click)="cerDownload(list)"
                      (keydown.enter)="cerDownload(list)"></i>&nbsp;
                    <i class="fas fa-cloud-download-alt" title="Evidence Download" style="margin-left: 5px;"
                      *ngIf="list['EVIDENCE_DOC_ID']!='' && list['EVIDENCE_DOC_ID']!=null" (click)="eviDownload(list)"
                      (keydown.enter)="eviDownload(list)"></i>
                    <i class="fa-solid fa-clipboard" title="Audit Trail" style="margin-left: 5px;"
                      *ngIf="message.isAuditTrailUser" (click)="openAuditTrail(list)"
                      (keydown.enter)="openAuditTrail(list)"></i>
                  </div>
                </td>
              </tr>
            </table>
          </div>
          <div class="d-flex justify-content-center">
            <div class="width-cheat small paginationCell">
              <div class="d-flex align-items-center gap-3">
                <div class="pagination_text mt-3">
                  {{ showingRowsText }}
                  1-{{ perPageSecond }} of {{ collectionSizeSecond | number }}
                </div>
                <div>
                  <ngb-pagination class="leftpadding"
                    (pageChange)="showOnlyConsider?setPageSecond1(pagerSecond.currentPage,$event):setPageSecond(pagerSecond.currentPage,$event)"
                    [disabled]="false" [collectionSize]="pagerSecond.totalItems" [(page)]="pagerSecond.currentPage"
                    [maxSize]="maxSize" [rotate]="true" [pageSize]="perPageSecond" [ellipses]="false"
                    [boundaryLinks]="true" size="sm">
                  </ngb-pagination>
                </div>
                <div ngbDropdown class="mt-3">
                  <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" ngbDropdownToggle>
                    {{ perPageSecond }}
                    <i class="ms-1 fa-solid fa-chevron-down"></i>
                  </button>
                  <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                    <button ngbDropdownItem (click)="paginationCallSecond(10)">10</button>
                    <button ngbDropdownItem (click)="paginationCallSecond(20)">20</button>
                    <button ngbDropdownItem (click)="paginationCallSecond(50)">50</button>
                  </div>
                  per page
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- details grid end-->
  <!--search elements-->
  <ng-template #searchUserPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelSearchManagerFunction()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{ popupData.title }}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="form-continer">
      <div class="row">
        <label for="" style="color:red;" *ngIf="noUserAlert">Please select user</label>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div><label for="email ">User Name</label></div>
          <input class="search-filed-continers uppercase" type="text" placeholder="Enter User Name"
            [(ngModel)]="searchByUserName">
          <div id="searchbyUserName-val-icon" class="field-icon-container"></div>
        </div>
        <div class="col-md-4">
          <div><label for="email">First Name</label></div>
          <input class="search-filed-continers" type="text" placeholder="Enter First Name"
            [(ngModel)]="searchByFirstName">
          <div class="field-icon-container"></div>
        </div>
        <div class="col-md-4">
          <div><label for="email">Last Name</label></div>
          <input class="search-filed-continers" type="text" placeholder="Enter Last Name"
            [(ngModel)]="searchByLastName">
          <div class="field-icon-container"></div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div><label for="email">Designation</label></div>
          <mat-select matInput placeholder="Select" [(ngModel)]="searchByDesignationCode"
            (closed)="designationSearchText=''" (click)="focusSearch('focus-title-search7')"
            (keydown.enter)="focusSearch('focus-title-search7')">
            <input type="search" id="focus-title-search7" class="dropdownsearchstyle"
              [(ngModel)]="designationSearchText" matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null"
              (onSelectionChange)="onDesignationSelect($event,null);">Un-select</mat-option>
            <mat-option *ngFor="let item of designationListDropdown | assessmentSearch : designationSearchText;"
              (onSelectionChange)="onDesignationSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-4">
          <div><label for="email">Department</label></div>
          <mat-select matInput placeholder="Select" [(ngModel)]="searchByDepartmentCode"
            (closed)="departmentSearchText=''" (click)="focusSearch('focus-title-search6')"
            (keydown.enter)="focusSearch('focus-title-search6')">
            <input type="search" id="focus-title-search6" class="dropdownsearchstyle" [(ngModel)]="departmentSearchText"
              matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null"
              (onSelectionChange)="onDesignationSelect($event,null);">Un-select</mat-option>
            <mat-option *ngFor="let item of departmentListDropdown | assessmentSearch : departmentSearchText;"
              (onSelectionChange)="onDepartmentSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>
      <div class="row" style="margin-top: 4%;">
        <div class="button-continer btn-align" mat-dialog-actions>
          <button mat-stroked-button class="addButton" (click)="searchUser()">
            <i class="fa-solid fa-magnifying-glass"></i> Search
          </button>
          <button mat-stroked-button class="cancelButton" (click)="resetSearchManagerGridDataFunction()">
            <i class="fa fa-repeat"></i> Reset
          </button>
        </div>
      </div>
      <div class="table-container" *ngIf="showUserSearchGrid">
        <table class="dynamic-table-container" style="height: 50vh;">
          <thead>
            <th style="min-width: 80px; text-align: center;">
              <div style="display: flex; justify-content: center; align-items: center;">
                <input id="selectAllUsersCheckbox" type="checkbox" style="zoom: 1.2;"
                  (change)="selectAllUsersChanged($event)">
              </div>
            </th>
            <th>
              <span>User Name</span>
              <span class="fa-solid fa-filter"></span>
            </th>
            <th>
              <span>First Name</span>
              <span class="fa-solid fa-filter"></span>
            </th>
            <th>
              <span>Last Name</span>
              <span class="fa-solid fa-filter"></span>
            </th>
            <th>
              <span>User Full Name</span>
              <span class="fa-solid fa-filter"></span>
            </th>
            <th>
              <span>Designation</span>
              <span class="fa-solid fa-filter"></span>
            </th>
            <th>
              <span>Department</span>
              <span class="fa-solid fa-filter"></span>
            </th>
            <th>
              <span>EmailAddress</span>
              <span class="fa-solid fa-filter"></span>
            </th>
            <th>
              <span>Contact Number</span>
              <span class="fa-solid fa-filter"></span>
            </th>
            <th>
              <span>Manager Name</span>
              <span class="fa-solid fa-filter"></span>
            </th>
            <th>
              <span>Is Ad User</span>
              <span class="fa-solid fa-filter"></span>
            </th>
            <th>
              <span>Is Factory User</span>
              <span class="fa-solid fa-filter"></span>
            </th>
            <th>
              <span>Is Active</span>
              <span class="fa-solid fa-filter"></span>
            </th>
            <th class="sticky-col first-col"></th>
          </thead>
          <tbody>
            <tr class="data-row-container" *ngFor="let listOfUsersData of getOneQmsUsersVwDetails; let idx = index;">
              <td style="min-width: 80px; text-align: center;">
                <div style="display: flex;">
                  <div [ngClass]="listOfUsersData.searchUserChildCheckBox ?'static_icon':'hover-menu-icons'">
                    <i class="fa-solid fa-ellipsis-vertical"></i>
                  </div>
                  <div style="margin-left: 5px;">
                    <input id="selectedManagerCheckBox" type="checkbox" style="zoom: 1.2;"
                      [checked]="listOfUsersData.searchUserChildCheckBox"
                      (change)="onChildCheckBoxChanged($event, listOfUsersData, idx)">
                  </div>
                </div>
              </td>
              <td class="row-data">{{ listOfUsersData.userName }}</td>
              <td class="row-data">{{ listOfUsersData.firstName }}</td>
              <td class="row-data">{{ listOfUsersData.lastName }}</td>
              <td class="row-data">{{ listOfUsersData.userFullName }}</td>
              <td class="row-data">{{ listOfUsersData.designation }}</td>
              <td class="row-data">{{ listOfUsersData.department }}</td>
              <td class="row-data">{{ listOfUsersData.emailAddress }}</td>
              <td class="row-data">{{ listOfUsersData.contactNumber }}</td>
              <td class="row-data">{{ listOfUsersData.managerName }}</td>
              <td class="row-data">
                <div class="icon-container"
                  [ngClass]="{'green-icon': listOfUsersData.isAdUser === 'Y', 'red-icon': listOfUsersData.isAdUser === 'N'}">
                  <svg width="20" height="20" *ngIf="listOfUsersData.isAdUser === 'Y'"
                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="green">
                    <path
                      d="M17.293 5.293l-1.414-1.414-6.293 6.293-2.293-2.293-1.414 1.414 3 3 .707.707.707-.707 7-7z" />
                  </svg>
                  <svg width="20" height="20" *ngIf="listOfUsersData.isAdUser === 'N'"
                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="red">
                    <path
                      d="M16 4.343l-1.414-1.414-4.586 4.586-4.586-4.586-1.414 1.414 4.586 4.586-4.586 4.586 1.414 1.414 4.586-4.586 4.586 4.586 1.414-1.414-4.586-4.586z" />
                  </svg>
                </div>
              </td>
              <td class="row-data">
                <div class="icon-container"
                  [ngClass]="{'green-icon': listOfUsersData.isFactoryUser === 'Y', 'red-icon': listOfUsersData.isFactoryUser === 'N'}">
                  <svg width="20" height="20" *ngIf="listOfUsersData.isFactoryUser === 'Y'"
                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="green">
                    <path
                      d="M17.293 5.293l-1.414-1.414-6.293 6.293-2.293-2.293-1.414 1.414 3 3 .707.707.707-.707 7-7z" />
                  </svg>
                  <svg width="20" height="20" *ngIf="listOfUsersData.isFactoryUser === 'N'"
                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="red">
                    <path
                      d="M16 4.343l-1.414-1.414-4.586 4.586-4.586-4.586-1.414 1.414 4.586 4.586-4.586 4.586 1.414 1.414 4.586-4.586 4.586 4.586 1.414-1.414-4.586-4.586z" />
                  </svg>
                </div>
              </td>
              <td class="row-data">
                <div class="icon-container"
                  [ngClass]="{'green-icon': listOfUsersData.isActive === 'Y', 'red-icon': listOfUsersData.stopReminders === 'N'}">
                  <svg width="20" height="20" *ngIf="listOfUsersData.isActive === 'Y'"
                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="green">
                    <path
                      d="M17.293 5.293l-1.414-1.414-6.293 6.293-2.293-2.293-1.414 1.414 3 3 .707.707.707-.707 7-7z" />
                  </svg>
                  <svg width="20" height="20" *ngIf="listOfUsersData.stopReminders === 'N'"
                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="red">
                    <path
                      d="M16 4.343l-1.414-1.414-4.586 4.586-4.586-4.586-1.414 1.414 4.586 4.586-4.586 4.586 1.414 1.414 4.586-4.586 4.586 4.586 1.414-1.414-4.586-4.586z" />
                  </svg>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions *ngIf="showUserSearchGrid">
      <button mat-stroked-button class="addButton" (click)="setUser()">
        <i class="fas fa-check"></i> Add
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelSearchManagerFunction()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </ng-template>
  <ng-template #searchTraining>
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelSearchTrainingFunction()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="form-continer">
      <div class="row">
        <label for=" " style="color:red;" *ngIf="noUserAlert">Please select training</label>
      </div>
      <div class="row">
        <div class="col-md-3">
          <div><label for="email">Training Name</label></div>
          <input class="search-filed-continers" type="text" placeholder="Enter Training Name"
            [(ngModel)]="searchByTrainingName">
          <div class="field-icon-container"></div>
        </div>
        <div class="col-md-3">
          <div><label for="email">Training Code</label></div>
          <input class="search-filed-continers" type="text" placeholder="Enter Training Code"
            [(ngModel)]="searchByTrainingCode">
          <div class="field-icon-container"></div>
        </div>
        <div class="col-md-3">
          <div><label for="email">Category</label></div>
          <mat-select matInput placeholder="Select" [(ngModel)]="searchByCategory" (closed)="categorySearchText=''"
            (click)="focusSearch('focus-title-search5')" (keydown.enter)="focusSearch('focus-title-search5')">
            <input type="search" id="focus-title-search5" class="dropdownsearchstyle" [(ngModel)]="categorySearchText"
              matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null"
              (onSelectionChange)="onCategorySelectNew($event,null);">Un-select</mat-option>
            <mat-option *ngFor="let item of categoryDropdown | assessmentSearch : categorySearchText;"
              (onSelectionChange)="onCategorySelectNew($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-3">
          <div><label for="email">Language</label></div>
          <mat-select matInput placeholder="Select" [(ngModel)]="searchByLanguage" (closed)="languageSearchText=''"
            (click)="focusSearch('focus-title-search4')" (keydown.enter)="focusSearch('focus-title-search4')">
            <input type="search" id="focus-title-search4" class="dropdownsearchstyle" [(ngModel)]="languageSearchText"
              matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null"
              (onSelectionChange)="onLangaugeSelectNew($event,null);">Un-select</mat-option>
            <mat-option *ngFor="let item of languageDropdown | assessmentSearch : languageSearchText;"
              (onSelectionChange)="onLangaugeSelectNew($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>
      <div class="row">
        <div class="button-continer btn-align" mat-dialog-actions>
          <button mat-stroked-button class="addButton" (click)="searchTrainingGridDataFunction()">
            <i class="fa-solid fa-magnifying-glass"></i> Search
          </button>
          <button mat-stroked-button class="cancelButton" (click)="resetSearchTrainingGridDataFunction()">
            <i class="fa fa-repeat"></i> Reset
          </button>
        </div>
      </div>
      <div class="table-container" *ngIf="showUserSearchGrid">
        <table class="search-manager-table-container" style="height: 50vh;">
          <thead>
            <th style="min-width: 80px; text-align: center;">
              <div style="display: flex; justify-content: center; align-items: center;">
                <input id="selectAllTrainingCheckbox" type="checkbox" style="zoom: 1.2;"
                  [checked]="searchUserParentCheckBox" (change)="selectAllTrainings($event)">
              </div>
            </th>
            <th> <span>Training Name</span> <span class="fa-solid fa-filter"></span>
            </th>
            <th> <span>Training Code</span> <span class="fa-solid fa-filter"></span>
            </th>
            <th> <span>Version</span> <span class="fa-solid fa-filter"></span>
            </th>
            <th> <span>Category</span> <span class="fa-solid fa-filter"></span>
            </th>
            <th> <span>Training Type</span> <span class="fa-solid fa-filter"></span>
            </th>
            <th> <span>Language</span> <span class="fa-solid fa-filter"></span>
            </th>
            <th class="sticky-col first-col"></th>
          </thead>
          <tbody>
            <tr class="data-row-container"
              *ngFor="let listOfUsersVwDetails of getTmsTrainingDetailsTableData; let idx = index;">
              <td style="min-width: 80px; text-align: center;">
                <div style="display: flex;">
                  <div [ngClass]="listOfUsersVwDetails.searchTrainingChildCheckBoxs ?'static_icon':'hover-menu-icons'">
                    <i class="fa-solid fa-ellipsis-vertical"></i>
                  </div>
                  <div style="margin-left: 5px;">
                    <input id="selectedUserCheckBox1" type="checkbox" style="zoom: 1.2;"
                      [checked]="listOfUsersVwDetails.searchTrainingChildCheckBoxs"
                      (change)="searchTrainingChildCheckBoxChecked($event, listOfUsersVwDetails, idx)">
                  </div>
                </div>
              </td>
              <td class="row-data">{{ listOfUsersVwDetails.trainingName }}</td>
              <td class="row-data">{{ listOfUsersVwDetails.trainingCode }}</td>
              <td class="row-data">{{ listOfUsersVwDetails.version }}</td>
              <td class="row-data">{{ listOfUsersVwDetails.categoryCode }}</td>
              <td class="row-data">{{ listOfUsersVwDetails.type }}</td>
              <td class="row-data">{{ listOfUsersVwDetails.language }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions *ngIf="showUserSearchGrid">
      <button mat-stroked-button class="addButton" (click)="addTrainingNameFunction()">
        <i class="fas fa-check"></i> Add
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelSearchTrainingFunction()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </ng-template>
  <!-- search instructor training -->
  <ng-template #searchInstructorTraining>
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelSearchInstructorTrainingFunction()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> Search Instructor Training</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="form-continer">
      <div class="row">
        <label for=" " style="color:red;" *ngIf="noUserAlert">Please select training</label>
      </div>
      <div class="row">
        <div class="col-md-3">
          <div><label for="email">Training Name</label></div>
          <input class="search-filed-continers" type="text" placeholder="Enter Training Name"
            [(ngModel)]="searchByInstructorTrainingName">
        </div>
        <div class="col-md-3">
          <div><label for="email">Version</label></div>
          <input class="search-filed-continers" type="text" placeholder="Enter Version" [(ngModel)]="searchByVersion">
        </div>
        <div class="col-md-3">
          <div><label for="email">Trainer Name</label></div>
          <input class="search-filed-continers" type="text" placeholder="Enter Trainer Name"
            [(ngModel)]="searchByTrainerName">
        </div>
        <div class="col-md-3">
          <div><label for="email">Training Mode</label></div>
          <input class="search-filed-continers" type="text" placeholder="Enter Training Mode"
            [(ngModel)]="searchByTrainingMode">
        </div>
        <div class="col-md-3">
          <div><label for="email">Status</label></div>
          <input class="search-filed-continers" type="text" placeholder="Enter Status" [(ngModel)]="searchByStatus">
        </div>
      </div>
      <div class="row">
        <div class="button-continer btn-align" mat-dialog-actions>
          <button mat-stroked-button class="addButton" (click)="searchInstructorTrainingGridDataFunction()">
            <i class="fa-solid fa-magnifying-glass"></i> Search
          </button>
          <button mat-stroked-button class="cancelButton" (click)="resetSearchInstructorTrainingGridDataFunction()">
            <i class="fa fa-repeat"></i> Reset
          </button>
        </div>
      </div>
      <div class="table-container" *ngIf="showInstructorTrainingSearchGrid">
        <table class="search-manager-table-container">
          <th style="min-width: 80px; text-align: center;">
            <div style="display: flex; justify-content: center; align-items: center;">
              <input id="selectAllTrainingCheckbox1" type="checkbox" style="zoom: 1.2;"
                (change)="selectAllInsTrainings($event)">
            </div>
          </th>
          <th> <span>Training Name</span> <span class="fa-solid fa-filter"></span>
          </th>
          <th> <span>Version</span> <span class="fa-solid fa-filter"></span>
          </th>
          <th> <span>Trainer Name</span> <span class="fa-solid fa-filter"></span>
          </th>
          <th> <span>Training Mode</span> <span class="fa-solid fa-filter"></span>
          </th>
          <th> <span>Status</span> <span class="fa-solid fa-filter"></span>
          </th>
          <th class="sticky-col first-col"></th>
          <tr class="data-row-container"
            *ngFor="let listOfUsersVwDetails of getTmsInstructorTrainingDetailsTableData; let idx = index;">
            <td style="min-width: 80px; text-align: center;">
              <div style="display: flex;">
                <div [ngClass]="listOfUsersVwDetails.searchTrainingChildCheckBoxs ?'static_icon':'hover-menu-icons'">
                  <i class="fa-solid fa-ellipsis-vertical"></i>
                </div>
                <div style="margin-left: 5px;">
                  <input id="selectedUserCheckBox" type="checkbox" style="zoom: 1.2;"
                    [checked]="listOfUsersVwDetails.searchTrainingChildCheckBoxs"
                    (change)="searchInstructorTrainingChildCheckBoxChecked($event, listOfUsersVwDetails, idx)">
                </div>
              </div>
            </td>
            <td class="row-data">{{ listOfUsersVwDetails.trainingName }}</td>
            <td class="row-data">{{ listOfUsersVwDetails.version }}</td>
            <td class="row-data">{{ listOfUsersVwDetails.trainerName }}</td>
            <td class="row-data">{{ listOfUsersVwDetails.trainingMode }}</td>
            <td class="row-data">{{ listOfUsersVwDetails.status }}</td>
          </tr>
        </table>
      </div>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions *ngIf="showInstructorTrainingSearchGrid">
      <button mat-stroked-button class="addButton" (click)="addInstructorTrainingNameFunction()">
        <i class="fas fa-check"></i> Add
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelSearchInstructorTrainingFunction()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </ng-template>
  <!--retake and Mark as completed-->
  <ng-template #retakeAndMarkasCompletedPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" mat-button (click)="cancelExportPopup()"><i
        class="fa popupClose">&#xf00d;</i></button>
    <h2 mat-dialog-title>{{popupTitle}}</h2>
    <div style="margin: 15px 15px;">
      <div class="form-continer">
        <div *ngIf="popupVal=='mark'">
          <div class="col-md-8">
            <div><label for="email">Completed Evidence</label><span class="mandatory-symbol">*</span>:
            </div>
            <button class="choose-file-btn" (click)="openFileDialog()">Upload
            </button>{{filename}}
            <input type="file" #fileInput style="display: none;" (change)="onFileSelected($event)" multiple />
          </div>
        </div>
        <div class="row">
          <div class="col-md-8" *ngIf="popupVal!='remove'">
            <div *ngIf="popupVal=='retake'" id="duedateValidation"><label for="email">Due
                Date</label><span class="mandatory-symbol">*</span> :
              <input type="text" class="form-control data-picker-continer" bsDatepicker
                [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses" [(ngModel)]="duedate"
                (ngModelChange)="changeExpcetedClosureOnDate($event)">
            </div>
            <div *ngIf="popupVal=='mark'" id="duedateValidation"><label for="email">Completed
                Date</label><span class="mandatory-symbol">*</span> :
              <input type="text" class="form-control data-picker-continer" bsDatepicker
                [bsConfig]="datePickerConfigurationComplete" [dateCustomClasses]="dateCustomClasses"
                [(ngModel)]="duedate" (ngModelChange)="changeExpcetedClosureOnDate($event)">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10">
            <div><label for="email" id="commentsValidation">Comments</label><span class="mandatory-symbol">*</span> :
            </div>
            <textarea class="input-filed-textarea" rows="4" cols="50" [(ngModel)]="comments"></textarea>
          </div>
        </div>
        <br>
      </div>
      <div class="button-continer btn-align" mat-dialog-actions>
        <button *ngIf="popupVal=='mark'" mat-stroked-button class="addButton"
          (click)="retakeAndMarkasCompletedFunc()">Mark as Completed</button>
        <button *ngIf="popupVal=='retake'" mat-stroked-button class="addButton"
          (click)="retakeAndMarkasCompletedFunc()">Re - Assign</button>
        <button *ngIf="popupVal=='remove'" mat-stroked-button class="addButton"
          (click)="retakeAndMarkasCompletedFunc()">Remove</button>
        <button mat-stroked-button class="cancelButton" (click)="cancelRetakeAndMarkasCompletedFunc()">
          <i class="fa fa-close"></i> Cancel
        </button>
      </div>
    </div>
  </ng-template>
  <!--Excell & pdf -->
  <ng-template #excelPdfPopup>
    <div class="page-loading-shade" *ngIf="appService.isProcessingRep">
      <app-custom-spinner *ngIf="appService.isProcessingRep"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelReportPopup()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div style="margin: 15px 15px;" class="align-center">
      <label for="email" style="font-size: medium; font-weight: bold;">Do you want to generate {{
        popupDataTitle.title }}
        ?</label>
    </div>
    <div style="margin: 15px 15px;" class="align-center" *ngIf="!isForExcel">
      <label for="email" style="font-size: .7rem; font-weight: bold;">
        <span *ngIf="!manuallyPicked">This report will include the first 10 columns by default</span>
        <span *ngIf="manuallyPicked && maxCountReached">
          We recommend selecting a maximum of 10 columns for a cleaner and more readable PDF
        </span>
      </label>
    </div>
    <div class="row " *ngIf="!isForExcel" style="margin:10px 10px 7% 10px;">
      <div class="col-md-12" *ngIf="selectedColumns.length">
        <div><label for="email">Selected Column(s)</label></div>
        <textarea id="selectedValuesTextarea" class="input-filed-textarea" style="margin-top: 8px; cursor: not-allowed;"
          rows="4" cols="50" [disabled]="true" [(ngModel)]="selectedColumnsAsString"></textarea>
      </div>
      <div class="row" [ngClass]="selectedColumns.length ? 'mt-3' : '' ">
        <div class="col-md-6">
          <label for="radio">PDF Page Size</label>
          <mat-radio-group [(ngModel)]="excelPdf.pdfPageSize">
            <mat-radio-button *ngFor="let data of pdfPageSizes"
              [value]="data.codelistCode">{{data.codelistName}}</mat-radio-button>
          </mat-radio-group>
        </div>
        <div class="col-md-6" style="margin-top: 1.5%;">
          <label for="toggle">Pick Columns Manually?</label>&nbsp;
          <mat-slide-toggle color="primary" (change)="onCheckboxChange($event)" [(ngModel)]="manuallyPicked"
            id="toggle">
            <ng-container *ngIf="manuallyPicked; else no">
              <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
            </ng-container>
            <ng-template #no>
              <span style="color: red;">No</span>
            </ng-template>
          </mat-slide-toggle>
        </div>

        <div class="row justify-content-md-center">
          <div class="col-sm-4">
            <label for="email">Report Logo</label>
          </div>
          <div class="col-sm-8">
            <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportLogoValue"
              (closed)="pdfDetailSearchText=''" (click)="focusSearch('focus-Logo-search')"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              <input type="search" id="focus-Logo-search" class="dropdownsearchstyle" [(ngModel)]="pdfDetailSearchText"
                matInput placeholder="search">
              <mat-option [value]="null" class="unselectStyle"
                (onSelectionChange)="onReportLogoValueSelect($event,null);">Un-select</mat-option>
              <mat-option *ngFor="let item of reportLogoDropdown | assessmentSearch : pdfDetailSearchText"
                (onSelectionChange)="onReportLogoValueSelect($event,item)" [value]="item.valueExp">
                {{ item.displayExp }}
              </mat-option>
            </mat-select>
          </div>
        </div>
        <div class="row justify-content-md-center">
          <div class="col-sm-4">
            <label for="email">Select Footer</label><span class="mandatory-symbol">*</span>
          </div>
          <div class="col-sm-8">
            <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportFooter"
              (closed)="pdfDetailSearchText=''" (click)="focusSearch('focus-Logo-search')"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              <input type="search" id="focus-footer-search" class="dropdownsearchstyle"
                [(ngModel)]="pdfDetailSearchText" matInput placeholder="search">

              <mat-option *ngFor="let item of reportFooterDropdown | assessmentSearch : pdfDetailSearchText"
                (onSelectionChange)="onReportFooterSelect($event,item)" [value]="item.displayExp">
                {{ item.displayExp }}
              </mat-option>
            </mat-select>
          </div>
        </div>
        <div class="row justify-content-md-center">
          <div class="col-sm-4">
            <label for="email">Is Save Report?</label>
          </div>
          <div class="col-sm-8">
            <mat-slide-toggle color="primary" name="reportEnabled" [(ngModel)]="isSaveReport">
              <ng-container *ngIf="isSaveReport; else noisSaveReport">
                <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
              </ng-container>
              <ng-template #noisSaveReport>
                <span style="color: red;">No</span>
              </ng-template>
            </mat-slide-toggle>
          </div>
        </div>
        <div class="row justify-content-md-center" *ngIf="isSaveReport">
          <div class="col-sm-4">
            <label for="email">Report Name</label>
          </div>
          <div class="col-sm-8">
            <input type="text" class="input-filed-continers" [(ngModel)]="reportName">
          </div>

        </div>
      </div>
      <div class="row mt-3" *ngIf="manuallyPicked">
        <div class="col-md-12">
          <div><label for="email">Select Column(s)</label><span class="mandatory-symbol">*</span></div>
          <mat-select matInput multiple placeholder="Select" #pdf id="execl-pdf" [(ngModel)]="selectedColumns"
            (closed)="pdfSearchText=''" (click)="focusSearch('focus-department-search')"
            (keydown.enter)="focusSearch('focus-department-search')">
            <input type="search" id="focus-department-search" class="dropdownsearchstyle" [(ngModel)]="pdfSearchText"
              matInput placeholder="search">
            <div class="select-all">
              <mat-checkbox [(ngModel)]="pdfSelection" (change)="toggleAllSelection('pdf')"> Select All</mat-checkbox>
            </div>
            <mat-option *ngFor="let item of excelPdf.dropDown | multiAssessmentSearchPipe : pdfSearchText"
              [value]="item.valueExp" (onSelectionChange)="onColumnSelect($event,item)">
              {{item.displayExp}}
            </mat-option>
          </mat-select>
        </div>

      </div>
    </div>
    <div class="button-continer btn-align" style="margin-top: 3%;" mat-dialog-actions>
      <button *ngIf="isForExcel" mat-stroked-button class="addButton" (click)="generateReport('Excel')">
        <i class="fa fa-file-excel-o"></i> Generate
      </button>
      <button *ngIf="!isForExcel" mat-stroked-button class="addButton" (click)="generateReport('Pdf')">
        <i class="fa fa-file-pdf-o"></i> Generate
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelReportPopup()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </ng-template>
  <ng-template #excelPdfPopupOrgMain>
    <div class="page-loading-shade" *ngIf="appService.isProcessingRep">
      <app-custom-spinner *ngIf="appService.isProcessingRep"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelReportPopup()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div style="margin: 15px 15px;" class="align-center">
      <label for="email" style="font-size: medium; font-weight: bold;">Do you want to generate {{ popupDataTitle.title
        }}
        ?</label>
    </div>
    <div class="button-continer btn-align" style="margin-top: 3%;" mat-dialog-actions>
      <button *ngIf="popupFlg=='main'" mat-stroked-button class="addButton" (click)="excelDownloadMaingrid()">
        <i class="fa fa-file-pdf-o"></i> Generate
      </button>
      <button *ngIf="popupFlg=='user'" mat-stroked-button class="addButton" (click)="excelDownloadMaingridOrg('user')">
        <i class="fa fa-file-pdf-o"></i> Generate
      </button>
      <button *ngIf="popupFlg=='training'" mat-stroked-button class="addButton"
        (click)="excelDownloadMaingridOrg('training')">
        <i class="fa fa-file-pdf-o"></i> Generate
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelReportPopup()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </ng-template>
  <ng-template #certificationPopup>
    <div class="ng-template-container" style="background-color: #f9f7f2;">
      <i class="fa fa-close pull-right" style="cursor: pointer;" title="Close" (click)="cancelCer()"
        (keydown.enter)="cancelCer()"></i>
      <i class="fa fa-download pull-right" style="cursor: pointer;" title="Download" (click)="downloadAsPdf()"
        (keydown.enter)="downloadAsPdf()"></i>

      <div id="dataToExport" class="row" *ngIf="!isDefaultTemplate">
        <div class="col-md-10" style="margin-top: 2%;padding-left: 4%;margin-bottom: 2%;">
          <div class="row text-center">
            <span *ngIf="
                    oneQmsOrgImagesDetails != null ||
                    oneQmsOrgImagesDetails != undefined
                  ">
              <img class="org-image" src="data:image/*;base64,{{ oneQmsOrgImagesDetails.logoImage }}" alt=""
                style="width: 60px; height: 60px" />
              <span style="display: inline-flex; width: 40%">{{
                orgData.orgLongName
                }}</span>
            </span>
          </div>
          <br />
          <div class="row text-center">
            <span class="cetificateTitle">Certificate of Completion</span>
          </div>
          <div class="row text-center" style="margin-top: 2%">
            <span style="color: gray; font-weight: 500"><i>This is to certify that</i></span>
          </div>
          <div class="row text-center" style="margin-top: 2%">
            <span style="font-weight: 600">{{ userDetails.firstName }}, {{ userDetails.lastName
              }}</span>
          </div>
          <div class="row text-center" style="margin-top: 2%">
            <span style="color: gray; font-weight: 500"><i>Has successfully completed the online
                course</i></span>
          </div>
          <div class="row text-center" style="margin-top: 2%">
            <span style="font-weight: 600">{{ trainingData.trainingName }}</span>
          </div>
          <div class="row text-center" style="margin-top: 2%"
            *ngIf="trainingData.finalScore!=null && trainingData.finalScore!=''">
            <span style="color: gray; font-weight: 500"><i>with score of {{ trainingData.finalScore }}%
                on</i></span>
          </div>
          <div class="row text-center" style="margin-top: 2%">
            <span style="font-weight: 600">{{
              trainingData.completedOn | date : "dd-MMM-yyyy"
              }}</span>
          </div>
          <hr style="border-top: 3px solid black" />
          <div class="row" *ngIf="isEsignRequired">
            <span style="color: gray; font-weight: 500"><i>{{ reasonForSign }} </i></span>
          </div>
          <div class="row" style="text-align: right; font-size: 11px; font-weight: 600" *ngIf="isEsignRequired">
            <span>{{ userDetails.firstName }}, {{ userDetails.lastName }}</span>
            <span>{{ userDetails.designation }}</span>
            <span>{{
              trainingData.completedOn | date : "dd-MMM-yyyy HH:mm:ss"
              }}</span>
            <span>I have read and understood training</span>
          </div>
        </div>
        <div class="col-md-2" style="
                height: auto;
                background-color: #f3caaf;
                width: 13%;
                margin-top: 2%;
                margin-bottom: 2%;
              "></div>
      </div>
      <div id="dataToExportFromTemp" *ngIf="isDefaultTemplate" [innerHTML]="certificateData"></div>
    </div>
  </ng-template>
  <!-- audit trails-->
  <app-static-audit-trail #auditTrailPopup></app-static-audit-trail>
  <!-- audit trails end-->
</div>
<app-grid-reorder #reorderPopup (valueEmitter)="onChildValueEmitted()"></app-grid-reorder>